(function (module) {
    "use strict";

    module.service('uiGridScrollExtension', ['ScrollEvent', '$q', function(this: $TSFixMe, ScrollEvent: $TSFixMe, $q: ng.IQService) {
        var service = this;


        service.getMiddleColumn = function (grid: $TSFixMe) {
            var self = grid;
            var visColCache = self.renderContainers.body.visibleColumnCache;
            var leftBound = self.renderContainers.body.prevScrollLeft;
            var rightBound = self.renderContainers.body.prevScrollLeft + Math.ceil(self.renderContainers.body.getViewportWidth());
            var centerOfGird = (rightBound + leftBound) / 2;

            var columnLeftEdge = 0;
            var columnRightEdge = 0;

            var middleColumn = null;
            for (var i = 0; i < visColCache.length; i++) {
                var col = visColCache[i];
                columnRightEdge += col.drawnWidth;

                if (columnLeftEdge <= centerOfGird && centerOfGird <= columnRightEdge) {
                    middleColumn = col;
                    break;
                }
                columnLeftEdge += col.drawnWidth;
            }
            return middleColumn;
        }

        service.scrollToColumn = function (grid: $TSFixMe, colDef: $TSFixMe) {
            var e = ScrollEvent;
            var self = grid;

            var gridCol = self.getColumn(colDef.name ? colDef.name : colDef.field);
            var gridRow = null;

            var scrollEvent = new ScrollEvent(self, 'uiGrid.scrollToIfNecessary');

            // Alias the visible row and column caches
            var visRowCache = self.renderContainers.body.visibleRowCache;
            var visColCache = self.renderContainers.body.visibleColumnCache;

            /*-- Get the top, left, right, and bottom "scrolled" edges of the grid --*/

            // The top boundary is the current Y scroll position PLUS the header height, because the header can obscure rows when the grid is scrolled downwards
            var topBound = self.renderContainers.body.prevScrollTop + self.headerHeight;

            // Don't the let top boundary be less than 0
            topBound = (topBound < 0) ? 0 : topBound;

            // The left boundary is the current X scroll position
            var leftBound = self.renderContainers.body.prevScrollLeft;

            // The bottom boundary is the current Y scroll position, plus the height of the grid, but minus the header height.
            //   Basically this is the viewport height added on to the scroll position
            var bottomBound = self.renderContainers.body.prevScrollTop + self.gridHeight - self.renderContainers.body.headerHeight - self.footerHeight - self.scrollbarWidth;

            // If there's a horizontal scrollbar, remove its height from the bottom boundary, otherwise we'll be letting it obscure rows
            //if (self.horizontalScrollbarHeight) {
            //  bottomBound = bottomBound - self.horizontalScrollbarHeight;
            //}

            // The right position is the current X scroll position minus the grid width
            var rightBound = self.renderContainers.body.prevScrollLeft + Math.ceil(self.renderContainers.body.getViewportWidth());

            // If there's a vertical scrollbar, subtract it from the right boundary or we'll allow it to obscure cells
            //if (self.verticalScrollbarWidth) {
            //  rightBound = rightBound - self.verticalScrollbarWidth;
            //}

            // We were given a column to scroll to
            if (gridCol !== null) {
                // This is the index of the column we want to scroll to, within the list of columns that can be visible
                var seekColumnIndex = visColCache.indexOf(gridCol);

                // Total horizontal scroll length of the grid
                var horizScrollLength = (self.renderContainers.body.getCanvasWidth() - self.renderContainers.body.getViewportWidth());

                // This is the minimum amount of pixels we need to scroll horizontal in order to see this column
                var columnLeftEdge = 0;
                for (var i = 0; i < seekColumnIndex; i++) {
                    var col = visColCache[i];
                    columnLeftEdge += col.drawnWidth;
                }
                columnLeftEdge = (columnLeftEdge < 0) ? 0 : columnLeftEdge;

                var columnRightEdge = columnLeftEdge + gridCol.drawnWidth;

                // Don't let the pixels required to see the column be less than zero
                columnRightEdge = (columnRightEdge < 0) ? 0 : columnRightEdge;

                var horizScrollPixels, horizPercentage;

                // If the scroll position we need to see the column is LESS than the left boundary, i.e. obscured before the left of the self...
                if (columnLeftEdge < leftBound 
                    || (columnLeftEdge >= leftBound && columnRightEdge <= rightBound)
                    || columnRightEdge > rightBound) {
                    // Get the different between the left boundary and the required scroll position and subtract it from the current scroll position\
                    //   to get the full position we need
                    horizScrollPixels = self.renderContainers.body.prevScrollLeft - (leftBound - columnLeftEdge);

                    // Turn the scroll position into a percentage and make it an argument for a scroll event
                    horizPercentage = horizScrollPixels / horizScrollLength;
                    horizPercentage = (horizPercentage > 1) ? 1 : horizPercentage;
                    scrollEvent.x = { percentage: horizPercentage };
                }
            }

            var deferred = $q.defer();

            // If we need to scroll on either the x or y axes, fire a scroll event
            if (scrollEvent.y || scrollEvent.x) {
                scrollEvent.withDelay = false;
                self.scrollContainers('', scrollEvent);
                var dereg = self.api.core.on.scrollEnd(null, function () {
                    deferred.resolve(scrollEvent);
                    dereg();
                });
            }
            else {
                deferred.resolve();
            }

            return deferred.promise;
        };

    }]);


})(angular.module('topline.app'));